import { createContext } from 'react';

// Whether what is inside is a card the action bar's trigger is picking right now (see BarTarget): its hover (the full
// card, see useHover) stays shut, as the popup by the mouse says what picking it would do
export const PickingContext = createContext(false);
